import React, { useCallback, useRef } from 'react';

import { FormHandles } from '@unform/core';
import * as Yup from 'yup';

import { FiX, FiPlus } from 'react-icons/fi';

import { Form, DivLeft } from './styles';

import Input from '../../../../../components/Global/Input';
import SelectSimple from '../../../../../components/Global/SelectSimple';
import Button from '../../../../../components/Global/Button';
import TextArea from '../../../../../components/Global/TextArea';

import Modal from '../../../../../components/Admin/Modal';
import getValidationErrors from '../../../../../utils/getValidationErrors';
import { FUEL_OPTIONS, vehicleSchema } from '../vehicleConstants';

interface IVehicles {
  name: string;
  plate: string;
  year: string;
  fuel: string;
  km: string;
  observations: string;
}

interface IModalProps {
  isOpen: boolean;
  setIsOpen: () => void;
  // eslint-disable-next-line no-unused-vars
  handleVehicle: (vehicle: IVehicles) => void;
}

const ModalAddVehicle: React.FC<IModalProps> = ({
  isOpen,
  setIsOpen,
  handleVehicle,
}) => {
  const formRef = useRef<FormHandles>(null);

  const handleSubmit = useCallback(
    async (data: IVehicles) => {
      try {
        formRef.current?.setErrors({});

        await vehicleSchema.validate(data, { abortEarly: false });

        handleVehicle({
          ...data,
          name: data.name.trim(),
          plate: data.plate.trim().toUpperCase(),
        });

        formRef.current?.reset();
        setIsOpen();
      } catch (err) {
        if (err instanceof Yup.ValidationError) {
          formRef.current?.setErrors(getValidationErrors(err));
        }
      }
    },
    [handleVehicle, setIsOpen],
  );

  const handleUpperCase = useCallback(
    (event: React.ChangeEvent<HTMLInputElement>) => {
      // eslint-disable-next-line no-param-reassign
      event.target.value = event.target.value.toUpperCase();
    },
    [],
  );

  return (
    <Modal isOpen={isOpen} setIsOpen={setIsOpen}>
      <Form ref={formRef} onSubmit={handleSubmit}>
        <span>
          <div>
            <h2>Adicionar novo veículo</h2>
            <FiPlus size={20} />
          </div>

          <FiX size={20} onClick={() => setIsOpen()} />
        </span>
        <header>
          <p>Nome do veículo</p>
          <Input type="text" name="name" placeholder="Ex: Fiat Strada" />

          <p>Placa do veículo</p>
          <Input
            name="plate"
            type="text"
            maxLength={8}
            onChange={handleUpperCase}
            placeholder="Ex: ABC1D23"
          />
        </header>

        <p>Ano do veículo</p>
        <Input type="text" name="year" placeholder="Ex: 2023 ou 2023/2024" />

        <p>Tipo de combustível</p>
        <SelectSimple
          name="fuel"
          options={FUEL_OPTIONS}
          placeholder="Selecione o combustível"
        />

        <p>Quilometragem atual</p>
        <Input type="number" name="km" min={0} placeholder="Ex: 1000" />

        <p>Observação geral</p>
        <TextArea
          name="observations"
          placeholder="Ex: Veículo entregue ao setor em estado novo"
        />

        <DivLeft>
          <Button type="submit" isUsed data-testid="add-food-button">
            Salvar
          </Button>
        </DivLeft>
      </Form>
    </Modal>
  );
};

export default ModalAddVehicle;
